// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1eef1a48","455":"0debd091","977":"26a4a579"}[chunkId] + ".chunk.js";
};